import React, { useState, useEffect, useContext } from "react";
import Images from "assets/images/imageData";
import localization from "assets/localization/localization";
import { Button } from "react-bootstrap";
import Layout from "components/sales/layout/layout";
import ModalPop from "components/sales/modal/modal";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import { useParams } from "react-router-dom";
import parse from "html-react-parser";
import ErrModalPop from "components/sales/modal/errorModal";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { handleValidateObj } from "constants/objValues/objvalues";
import { validateObject } from "constants/objValues/validateObject";
import useLatLng from "hooks/uselatlng/uselatlng";
import CardSection from "components/sales/cardSection/cardSection";
import { FormGroup } from "react-bootstrap";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import { DatePickerInput } from "rc-datepicker";
import TimePicker from "react-times";
import ConstantInput from "../../../../components/sales/Input/constantInput/constantInput";

const CheckIn = ({
  createMeeting,
  updateMeeting,
  match,
  history,
  getMeetingById,
  getCorpClientList,
  corpClientList,
  getInvoiceList,
  saveCheckinForMeeting,
}) => {
  const { id } = useParams();
  const [isFiled, setIsFiled] = useState(false);
  const [siteId, setSiteId] = useState();
  const { baseUrl } = useContext(BaseUrl);
  var currentDate = new Date();
  var day = currentDate.getDate();
  var month = currentDate.getMonth() + 1;
  var year = currentDate.getFullYear();
  day = day < 10 ? "0" + day : day;
  month = month < 10 ? "0" + month : month;
  var formattedDate = year + "-" + month + "-" + day;
  const inputs = {
    site_id: "",
    other_site_id: "",
    meeting_mode: "",
    meetingDetails: null,
    scheduled_date: formattedDate,
    scheduled_time: `${new Date().getHours()}:${new Date().getMinutes()}`,
    lat: 0,
    lng: 0,
  };
  const [meetingData, setCorporateData] = useState(inputs);
  const [formData, setData] = useState(inputs);
  const [isLoading, setIsLoading] = useState(false);
  const [teamId, setTeamId] = useState();
  const [isModal, setIsModal] = useState(false);
  const [selectSiteId, setSelectSiteId] = useState(0);
  const [errorMsg, setIsErrorMsg] = useState("");
  const [isErrorModal, setIsErrorModal] = useState(false);
  const [meetingId, setMeetingId] = useState(null);
  const [draftModalVisible, setDraftModalVisible] = useState(false);
  const islatlng = useLatLng();
  const [isAllow, setIsAllow] = useState(false);
  const [isFocus, setIsFocus] = useState(true);
  const [mapLocation, setMapLocation] = useState({
    address: "Delhi",
    lat: 0,
    lng: 0,
  });

  useEffect(() => {
    if (islatlng === false) {
      setIsAllow(true);
    } else {
      setIsAllow(false);
    }
    var lati = Number(islatlng?.lat);
    var langi = Number(islatlng?.lng);
    if (!isNaN(lati) && !isNaN(langi)) {
      setMapLocation({
        address: "Delhi6",
        lat: Number(islatlng?.lat),
        lng: Number(islatlng?.lng),
      });
      setData((prevData) => ({
        ...prevData,
        lat: Number(islatlng?.lat),
        lng: Number(islatlng?.lng),
      }));
    }
  }, [islatlng]);

  useEffect(() => {
    if (
      mapLocation?.lat &&
      mapLocation?.lat !== null &&
      getCorpClientList !== null
    )
      (async () => {
        setIsLoading(true);
        await getCorpClientList(
          match.params.siteId,
          mapLocation?.lat,
          mapLocation?.lng
        );
        setIsLoading(false);
      })();
  }, [getCorpClientList, match.params.siteId, mapLocation?.lat]);

  const handleModalHide = () => {
    setIsModal(false);
    history.push(`${baseUrl}/brand-activation/scheduled-meeting`);
  };

  const handleCheckIn = () => {
    if (
      (formData.site_id === 0 || formData.site_id === -1) &&
      !formData.meeting_mode
    ) {
      toast.error("Please select F2F or Virtual Meeting");
      return;
    }
    (async () => {
      // console.log('Form Data:', formData)
      // return false;
      setIsLoading(true);
      const res = await saveCheckinForMeeting(formData);
      console.log(res);
      if (res) {
        setIsModal(true);
      } else {
        setIsLoading(false);
        // var errMsg = "Something went wrong!";
        // setIsErrorMsg(errMsg);
        // setIsErrorModal(true);
        // setIsFiled(true);
        // setIsModal(false);
        return false;
      }
      setIsLoading(false);
      setDraftModalVisible(true);
    })();
  };

  const handleDateHide = () => {
    if (formData.scheduled_date) {
      setIsFocus(true);
    }
  };

  const handleDraftModalHide = () => {
    setDraftModalVisible(false);
  };

  function onChange(value) {
    const { hour, minute } = value;
    setData({ ...formData, scheduled_time: `${hour}:${minute}` });
  }

  const handleDateChange = (date, dateString) => {
    setData({ ...formData, scheduled_date: dateString });
  };

  // const getInvoicesAgainstSite = async (siteId) => {
  //   if (siteId != "" && siteId != undefined) {
  //     const invoices = getInvoiceList(siteId);
  //   }
  // };

  const headerBtns = () => {
    return (
      <>
        <Button onClick={handleCheckIn} className="btn btn-primary">
          {localization.checkIn}
        </Button>
      </>
    );
  };

  const handleModalHide1 = () => setIsErrorModal(false);
  return (
    <Layout
      title={localization.checkIn}
      Buttons={headerBtns}
      className={isFiled ? "requiredFileds" : ""}
      isGoback
      isLoading={isLoading}
      linkUrl={`${baseUrl}/brand-activation/scheduled-meeting`}
    >
      <CardSection title={localization.checkinDetails}>
        <div className="row">
          <div className="col-md-12">
            <div className="panel-heading messageBox">
              <div>
                Lat. : {mapLocation?.lat}
                &nbsp; Long. : {mapLocation?.lng}
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <DropDownInput
              data={corpClientList.sites}
              label={localization.clientName}
              required
              getIdValue={(val) => {
                  setData({
                    ...formData,
                    site_id: val.id,
                    meeting_mode:
                      val.id === 0 || val.id === -1 ? formData.meeting_mode : "",
                  });
                setSelectSiteId(val.id);
                // getInvoicesAgainstSite(val.id);
              }}
              errorMsg={localization.requiredName}
              isStarRequired={true}
            />
          </div>
          {formData.site_id === 0 && (
                <div className="col-md-6">
                  <DropDownInput
                    data={corpClientList.other_sites}
                    label={localization.otherSites}
                    required
                    getIdValue={(val) => {
                      setData({
                        ...formData,
                        other_site_id: val.id,
                      });
                      setSelectSiteId(val.id);
                      // getInvoicesAgainstSite(val.id);
                    }}
                    errorMsg={localization.requiredName}
                    isStarRequired={true}
                  />
                </div>
          )}
          {formData.site_id === -1 && (
              <>
                <div className="col-md-6">
                  <DropDownInput
                      data={[{id:"Brand Meeting", name:"Brand Meeting"},
                        {id:"Tenant Meeting", name:"Tenant Meeting"},
                        {id:"Builder Office", name:"Builder Office"},
                        {id:"New site visit", name:"New site visit"}
                      ]}
                      label={localization.otherSites}
                      required
                      getIdValue={(val) => {
                        setData({
                          ...formData,
                          other_site: val.id,
                        });
                        // setSelectSiteId(val.id);
                        // getInvoicesAgainstSite(val.id);
                      }}
                      errorMsg={localization.requiredName}
                      isStarRequired={true}
                  />
                </div>
                <div className="col-md-6">
                  <ConstantInput
                      label={localization.client}
                      required
                      handleChange={(value) => {
                        setData({
                          ...formData,
                          other_client_name: value
                        })                      
                      }}
                      errorMsg={localization.requiredName}
                      isStarRequired={true}
                  />
                  
                </div>
              </>
          )}
          {(formData.site_id === 0 || formData.site_id === -1) && (
            <div className="col-md-6">
              <DropDownInput
                data={[
                  { id: "F2F", name: "F2F" },
                  { id: "VIRTUAL", name: "Virtual Meeting" },
                ]}
                label={localization.meetingType}
                required
                getIdValue={(val) => {
                  setData({
                    ...formData,
                    meeting_mode: val.id,
                  });
                }}
                errorMsg={localization.requiredName}
                isStarRequired={true}
              />
            </div>
          )}
          <div className="col-md-6">
            <FormGroup
              className={`date custom_date_picker ${
                isFocus ? "active-date" : ""
              }`}
            >
              <DatePickerInput
                value={formData.scheduled_date}
                onChange={handleDateChange}
                onShow={() => setIsFocus(true)}
                onHide={handleDateHide}
                onClear={() => setIsFocus(false)}
                autoClose
                closeOnClickOutside
                showOnInputClick
                locale="en"
                className="my-custom-datepicker-component"
                required
                displayFormat="DD-MM-YYYY"
                returnFormat="YYYY-MM-DD"
                maxDate={new Date()}
                disabled
              />

              <label>
                {localization.selectDate}
                <span className="label-star" style={{ color: "red" }}>
                  {" "}
                  *{" "}
                </span>
              </label>
              {!isFocus && (
                <label className="error date_error">
                  {localization.isRequired}
                </label>
              )}
            </FormGroup>
          </div>
          <div className="col-md-6">
            <FormGroup>
              <TimePicker
                theme="classic"
                timeFormat="HH:MM"
                timeMode={24}
                time={formData?.scheduled_time}
                onTimeChange={onChange}
                disabled
              />
              <label>{localization.selectTime}</label>
              <label className="error date_error">
                {localization.isRequired}
              </label>
            </FormGroup>
          </div>
        </div>
      </CardSection>

      <ErrModalPop
        title={localization.error}
        show={isErrorModal}
        handleModalHide={handleModalHide1}
        keyboard
        backdrop
      >
        <div className="text-center">{parse(errorMsg)}</div>
      </ErrModalPop>

      <ModalPop
        title={localization.conf}
        show={draftModalVisible}
        handleModalHide={handleDraftModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.checkInSucess}</h5>
          <Button onClick={handleModalHide} className="btn btn-primary mb-4">
            {localization.goToMeetingList}{" "}
            <img src={Images?.ArrowRight} alt="" />
          </Button>
          &nbsp;
          {meetingId && siteId ? (
            <Link
              to={`${baseUrl}/brand-activation/create-mom/${siteId}/${meetingId}`}
              className="btn btn-primary mb-4"
            >
              {localization.createMom}{" "}
            </Link>
          ) : null}
        </div>
      </ModalPop>

      <ErrModalPop
        title={localization.error}
        show={isErrorModal}
        handleModalHide={handleModalHide1}
        keyboard
        backdrop
      >
        <div className="text-center">{parse(errorMsg)}</div>
      </ErrModalPop>
    </Layout>
  );
};

CheckIn.propTypes = {};

export default CheckIn;
